<template>
  <div>
    <h2 class="step-name">Down Cow / Metabolic Issues</h2>

    <div class="step-section">
      <h3>Down cow products purchased</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Season</th>
            <th>Product</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(dcp, index) in model.CHARTS.downcow_products" :key="index"
            :class="getRowClass(model.CHARTS.downcow_products, 'Season', index)">

            <td class="text-left">{{ dcp["Season"] }}</td>
            <td class="text-left">{{ dcp["Product"] }}</td>
            <td class="text-left">{{ dcp["Quantity"] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-section">
      <div class="form-group">
        <label for="downcow_meta_keypoints">Key Points</label>
        <textarea rows="5" cols="50" v-model="model.downcow_meta_keypoints" class="form-control" :disabled="isReadOnly">
        </textarea>
      </div>

      <div class="form-group">
        <label for="downcow_meta_actions">Actions</label>
        <textarea rows="5" cols="50" v-model="model.downcow_meta_actions" class="form-control" :disabled="isReadOnly">
        </textarea>
      </div>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component'

export default {
  mixins: [ baseComponent ],
  data() {
    return {
      model: {
        wants_agvance_transition_salts: "",
        downcow_meta_keypoints: "",
        downcow_meta_actions: "",
        CHARTS: {
          downcow_products: [],
        },
      },
    }
  },
};
</script>
